import { useAuth0Users } from '~/queries/users'
import type { PolicyRoom } from '~/composables/usePolicyRoom'
import {
  buildMentionables,
  type Mentionable,
} from '~/utils/policy-studio/conversation'

/**
 * Who can be tagged in a policy's threads: each Studio team (`@scoping`,
 * reaching everyone on it), then people, keyed by lower-cased email.
 *
 * The directory needs `readUsersAll`; without it (a 403) the people already
 * in this policy — owners, authors, askers — are the whole list.
 */
export const usePolicyMentionables = (
  room: PolicyRoom,
): ComputedRef<Mentionable[]> => {
  const { data } = useAuth0Users()
  return computed(() =>
    buildMentionables(
      data.value?.result ?? [],
      room.view.value,
      room.comments.value.map((comment) => comment.author),
    ),
  )
}
